import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  groupMemberChangeUserGroup,
  superUserChangeUserGroup,
} from 'modules/common/userGroupManagement/data/actions';

import {
  getAvailableGroupMembers,
  getIsSuperuser,
} from 'store/session/selectors';

export const useSwitchGroup = () => {
  const dispatch = useDispatch();
  const isSuperUser = useSelector(getIsSuperuser);
  const availableGroupMembers = useSelector(getAvailableGroupMembers);

  const groupIdToMemberMap = useMemo(
    () =>
      Object.fromEntries(
        availableGroupMembers.map((member) => [member.group.id, member]),
      ),
    [availableGroupMembers],
  );
  return useCallback(
    async (userGroupId: number, nextUrl: string) => {
      const groupMemberId = groupIdToMemberMap[userGroupId]?.id;
      if (isSuperUser && userGroupId) {
        dispatch(
          superUserChangeUserGroup.request({
            userGroupId,
            nextUrl,
          }),
        );
      } else if (groupMemberId) {
        dispatch(
          groupMemberChangeUserGroup.request({
            groupMemberId,
            nextUrl,
          }),
        );
      }
    },
    [dispatch, groupIdToMemberMap, isSuperUser],
  );
};
